export default "__VITE_ASSET__CRWEuong__"